import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logoCCBJI from "@/assets/img/2800_CCBJI_Logo.bmp";
import logoFVJ from "@/assets/img/2801_FVJ_Logo.bmp";
import {
    HomeFilled,
    SettingFilled,
    LockFilled,
    ReadFilled
} from '@ant-design/icons';
import { Space } from "antd";
import { COMPANY_CODE, RESPONSE_ERR } from "@/constant";
import storage from "@/utils/storage";

export type SideMenuProps = {
    toggleMenu: any;
    companyCode: any;
    nameUser: any;
};

const nav = {
    'home': 'ホーム',
    'setting': 'サービス内容の変更',
    'change_password': 'パスワードの変更',
    'privacy_policy': '規約関連'
}


export const SideMenu = ({ toggleMenu, companyCode, nameUser }: SideMenuProps) => {
    const getToken = storage.getToken();
    const getType = JSON.parse(window.localStorage.getItem(`dpds_type`) || 'null') ? JSON.parse(window.localStorage.getItem(`dpds_type`) || 'null') : null;
    const [token, setToken] = useState(getToken);
    const [type, setType] = useState(getType);
    const navigate = useNavigate();
    useEffect(() => {
        setToken(getToken);
        setType(getType);
    }, [getToken, getType]);


    let logoCompany = logoCCBJI
    if (companyCode) {
        if (companyCode == COMPANY_CODE.FVJ) {
            logoCompany = logoFVJ;
        } else {
            logoCompany = logoCCBJI;
        }
    }

    return (
        <div className="sidemenu">
            <div className="top-of-sidebar">
                <div className="top-sidebar-content">
                    <div className="infor-sidebar" style={{ height: 'auto' }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="#007bff"
                            className="h-10 w-10 text-primary-color-blue"
                            height={40}
                            width={40}
                        >
                            <path
                                fillRule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                                clipRule="evenodd"
                            />
                        </svg>
                        <span className="text-dark align-items-center text-left"
                            style={{ fontSize: '13px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', width:'165px', lineHeight:'40px' }}
                            data-bs-toggle="tooltip"
                            title={nameUser}
                        >
                            {nameUser}
                        </span>
                        <button className="btn border-0 p-0 d-flex align-items-center justify-content-center" onClick={toggleMenu}>
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <line
                                    x1="1.5"
                                    y1="2.5"
                                    x2="22.5"
                                    y2="2.5"
                                    stroke="#6C7072"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                />
                                <line
                                    x1="4.5"
                                    y1="10.5"
                                    x2="22.5"
                                    y2="10.5"
                                    stroke="#6C7072"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                />
                                <line
                                    x1="14.5"
                                    y1="18.5"
                                    x2="22.5"
                                    y2="18.5"
                                    stroke="#6C7072"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div className="mt-1"></div>
            {token && !(type === "E0104" || type === "E0105") && <>
                <NavLink tabIndex={0} className="link" to="/" onClick={toggleMenu} >
                    <Space>
                        <HomeFilled style={{ fontSize: '16px', color: '#808080' }} />
                        {nav.home}
                    </Space>
                </NavLink>
                <NavLink tabIndex={0} className="link" to="/setting" onClick={toggleMenu}>
                    <Space>
                        <SettingFilled style={{ fontSize: '16px', color: '#808080' }} />
                        {nav.setting}
                    </Space>
                </NavLink>
                <NavLink tabIndex={0} className="link" to="/change-password" onClick={toggleMenu} >
                    <Space>
                        <LockFilled style={{ fontSize: '16px', color: '#808080' }} />
                        {nav.change_password}
                    </Space>
                </NavLink>
                <NavLink tabIndex={0} className="link" to="/privacy-policy" onClick={toggleMenu} >
                    <Space>
                        <ReadFilled style={{ fontSize: '16px', color: '#808080' }} />
                        {nav.privacy_policy}
                    </Space>
                </NavLink>
            </>}
        </div>
    )
};
